import { LitElement, html } from 'lit';
import { styles } from './css';
import {
  fetchCart,
  checkProductAvailability,
  addToCart,
} from '@Root/spree/api';
import {
  updateCartIndicator,
  changeProductNameInModal,
  changeProductImageInModal,
  changeProductSizeInfoInModal,
} from '@Root/spree/dom';
import { logErrorToSentry } from '../../../../helpers/helpers';
import find from 'lodash.find';

import {
  SHARED_CLASSES,
  SHARED_ELEMENTS,
} from '@Root/lib/lit-3form-block/styles.js';

import { useCartConfirmationModal } from '../../../../helpers/helpers';
import { debounce } from '../../../../helpers/debounce';

import { LIT_CSS_VARIABLES, GRID_LAYOUT } from '@Root/lib/lit-styles.js';
import { a11yStyles } from '../../../form-controls/a11y-styles';
import { choiceStyles } from '../../../form-controls/choice-styles';
export class CutToOrderBarrel extends LitElement {
  static get properties() {
    return {
      content: { type: Object },
      _ctaDisabled: { type: Boolean },
      _selectedHeight: { type: Number },
      _selectedWidth: { type: Number },
      _selectedQuantity: { type: Number },
      _selectedLaminate: { type: Object },
      _selectedEdgeFinish: { type: Object },
      _selectedPatternDirection: { type: Object },
      _currentSelectionSpreeData: { type: Object },
      _productIsAvailable: { type: Boolean },
    };
  }

  static get styles() {
    return [
      LIT_CSS_VARIABLES,
      SHARED_ELEMENTS,
      SHARED_CLASSES,
      GRID_LAYOUT,
      styles,
      a11yStyles,
      choiceStyles,
    ];
  }

  constructor() {
    super();
    this.content = JSON.parse(this.getAttribute('content'));
    this._ctaDisabled = false;
    this._selectedHeight = null;
    this._selectedWidth = null;
    this._selectedQuantity = 1;
    this._selectedLaminate = {};
    this._selectedEdgeFinish = {};
    this._currentSelectionSpreeData = null;
    this._productIsAvailable = false;
    this._debouncedUpdateSpreeData = debounce(() => this.updateSpreeData());
  }

  async connectedCallback() {
    super.connectedCallback();

    try {
      await this.setupSpreeData();
    } catch (error) {
      logErrorToSentry(error);
    }

    this._selectedLaminate = this.my3formLaminates[0];
    this._selectedEdgeFinish = this.edgeFinishOptionsArr[0];
  }

  render() {
    return html`
      <div class="barrel-wrapper-expanded print-none">
        <div class="barrel-header">
          <span class="barrel-heavy-text">
            <span>CHOOSE YOUR PRODUCT</span>
          </span>
        </div>
        <div
          class="gauge-selection"
          role="radiogroup"
          aria-label="Choose laminate"
        >
          <span class="barrel-heavy-text" aria-hidden="true"></span>
          <span class="barrel-heavy-text" aria-hidden="true">Gauge</span>
          <span class="barrel-heavy-text" aria-hidden="true">Front Finish</span>
          <span class="barrel-heavy-text" aria-hidden="true">Back Finish</span>
          ${this.my3formLaminates.map((laminate, index) =>
            this.gaugeSelectionRowHTML(laminate, index)
          )}
        </div>
      </div>
      <div class="barrel-wrapper-expanded print-none">
        <div class="barrel-header">
          <span class="barrel-heavy-text">
            <span>SPECIFY YOUR ORDER</span>
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header with-input">
            <label for="cut-to-order-width" class="barrel-heavy-text"
              >Width</label
            >
          </span>
          <span class="input-row-value">
            <input
              id="cut-to-order-width"
              type="number"
              .value="${this._selectedWidth}"
              min="1"
              step="1"
              max="48"
              placeholder="Inches"
              aria-describedby="cut-to-order-width-help"
              @input="${this.widthSelectedChanged}"
            />
            <p id="cut-to-order-width-help" class="barrel-text help-text">
              Maximum width is 48.00 inches
            </p>
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header with-input">
            <label for="cut-to-order-height" class="barrel-heavy-text"
              >Height</label
            >
          </span>
          <span class="input-row-value">
            <input
              id="cut-to-order-height"
              type="number"
              .value="${this._selectedHeight}"
              min="1"
              step="1"
              max="96"
              placeholder="Inches"
              aria-describedby="cut-to-order-height-help"
              @input="${this.heightSelectedChanged}"
            />
            <p id="cut-to-order-height-help" class="barrel-text help-text">
              Maximum height is 96.00 inches
            </p>
          </span>
        </div>
        ${this.patternDirectionText
          ? html`
              <div class="input-row-wrapper">
                <span class="input-row-header">
                  <p class="barrel-heavy-text">Pattern Direction</p>
                </span>
                <span class="input-row-value">
                  <p class="barrel-text">${this.patternDirectionText}</p>
                </span>
              </div>
            `
          : html``}
        <div class="input-row-wrapper">
          <span class="input-row-header">
            <p id="cut-to-order-edge-label" class="barrel-heavy-text">
              Edge Finish
            </p>
          </span>
          <span
            class="input-row-value column-direction"
            role="radiogroup"
            aria-labelledby="cut-to-order-edge-label"
          >
            ${this.edgeFinishOptionsArr.map((edgeFinishOption, index) =>
              this.edgeFinishOptionsHTML(edgeFinishOption, index)
            )}
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header with-input">
            <label for="cut-to-order-qty" class="barrel-heavy-text"
              >Quantity</label
            >
          </span>
          <span class="input-row-value">
            <input
              id="cut-to-order-qty"
              type="number"
              .value="${this._selectedQuantity}"
              min="1"
              step="1"
              @input="${this.quantitySelectedChanged}"
            />
          </span>
        </div>
        <div class="input-row-wrapper">
          <span class="input-row-header"></span>
          <span class="input-row-value">
            <div class="totals-wrapper">
              <div class="order-totals">
                <p class="barrel-heavy-text">Total(USD)</p>
                <p class="barrel-heavy-text">${this.totalPriceString}</p>
              </div>
              <cta-button
                class="cta-btn"
                cta-data=${this.ctaData}
                cta-type="primary"
                @click="${() => this.addSelectedProductToCart()}"
                .disabled="${this.ctaDisabled}"
              ></cta-button>
            </div>
          </span>
        </div>
      </div>
    `;
  }

  gaugeSelectionRowHTML(laminate, index) {
    const gaugeLabelId = `laminate-${laminate.external_id}-gauge`;
    const frontLabelId = `laminate-${laminate.external_id}-front`;
    const backLabelId = `laminate-${laminate.external_id}-back`;
    return html`
      <span class="tf-choice__control tf-choice__control--radio">
        <input
          type="radio"
          id="${laminate.external_id}"
          name="laminates"
          value="${laminate.external_id}"
          aria-labelledby="${gaugeLabelId} ${frontLabelId} ${backLabelId}"
          .checked="${laminate.external_id ===
            this._selectedLaminate.external_id}"
          @change="${() => {
            this.updateSelectedLaminate(laminate.external_id);
          }}"
        />
        <span class="tf-choice__control-fill"></span>
      </span>
      <label
        id=${gaugeLabelId}
        for=${laminate.external_id}
        class="tf-choice__text"
      >
        ${laminate.gauge.description}
      </label>
      <label
        id=${frontLabelId}
        for=${laminate.external_id}
        class="tf-choice__text"
      >
        ${laminate.front_finish.description}
      </label>
      <label
        id=${backLabelId}
        for=${laminate.external_id}
        class="tf-choice__text"
      >
        ${laminate.back_finish.description}
      </label>
    `;
  }

  edgeFinishOptionsHTML(edgeFinishOption, index) {
    return html`
      <label class="tf-choice">
        <span class="tf-choice__control tf-choice__control--radio">
          <input
            type="radio"
            name="edgeFinishOptions"
            value="${edgeFinishOption[0]}"
            .checked="${this._selectedEdgeFinish[0] === edgeFinishOption[0]}"
            @change="${() => {
              this.updateSelectedEdgeFinish(edgeFinishOption);
            }}"
          />
          <span class="tf-choice__control-fill"></span>
        </span>
        <span class="tf-choice__text">${edgeFinishOption[1]}</span>
      </label>
    `;
  }

  get edgeFinishOptionsArr() {
    if (this.content.direct_product_choices) {
      const edgeFinishOptions = this.content.direct_product_choices.find(
        ({ name }) => name === 'edge_finish'
      );
      return edgeFinishOptions?.option_groups[0]?.options || [];
    }
    return [];
  }

  get my3formLaminates() {
    return this.content.my3form_laminates;
  }

  updateSelectedLaminate(id) {
    this._selectedLaminate = this.my3formLaminates.find(laminate => {
      return laminate.external_id === id;
    });
    this.updateSpreeData();
  }

  updateSelectedEdgeFinish(edgeFinish) {
    this._selectedEdgeFinish = edgeFinish;
    this.updateSpreeData();
  }

  heightSelectedChanged(event) {
    if (!event || isNaN(event.target?.value)) return;

    let newValue = event.target.value < 0 ? null : event.target.value;
    if (newValue > 96) newValue = 96;
    if (newValue === this._selectedHeight) return;

    this._selectedHeight = newValue;
    this._debouncedUpdateSpreeData();
  }

  widthSelectedChanged(event) {
    if (!event || isNaN(event.target?.value)) return;

    let newValue = event.target.value < 0 ? null : event.target.value;
    if (newValue > 48) newValue = 48;
    if (newValue === this._selectedWidth) return;

    this._selectedWidth = newValue;
    this._debouncedUpdateSpreeData();
  }

  quantitySelectedChanged(event) {
    if (event) {
      if (isNaN(event.target.value)) return;
      let newValue = event.target.value < 0 ? null : event.target.value;
      if (newValue != this._selectedQuantity) {
        this._selectedQuantity = newValue;
        this.updateSpreeData();
      }
    }
  }

  get ctaData() {
    return JSON.stringify({
      text: 'Add to Cart',
      url: '',
      fullWidth: true,
    });
  }

  get patternDirectionText() {
    return this.content.direct_product_pattern_direction || '';
  }

  async updateSpreeData() {
    if (this.allInputsAreValid) {
      await this.getSpreeData(this.spreeParamsObject)
        .then(json => {
          if (json.price) {
            json.price = this.roundedPrice(json.price);
            this._currentSelectionSpreeData = json;
          }
          this.setupSpreeData();
          this._ctaDisabled = false;
        })
        .catch(error => {
          logErrorToSentry(error);
        });
    } else {
      this._currentSelectionSpreeData = null;
    }
  }

  roundedPrice(num) {
    return Math.round(num * 100) / 100;
  }

  formattedDisplayPrice(num) {
    let USDollar = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return USDollar.format(num);
  }

  get totalPriceString() {
    let str = '';
    if (this._selectedQuantity && this._currentSelectionSpreeData) {
      const total =
        this._selectedQuantity * this._currentSelectionSpreeData.price;
      str = this.formattedDisplayPrice(total.toFixed(2));
    }
    return str;
  }

  get spreeParamsObject() {
    return {
      laminate_id: this._selectedLaminate.external_id,
      width: this._selectedWidth,
      height: this._selectedHeight,
      my3form_edge_finish_id: this._selectedEdgeFinish[0],
    };
  }

  get allInputsAreValid() {
    return Object.values(this.spreeParamsObject).every(value => !!value);
  }

  getSpreeData(newParams) {
    const params = new URLSearchParams(newParams);

    const spreeDataUrl = `${document.URL}/cut_to_order?${params}`;

    const init = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    this._ctaDisabled = true;
    this.requestUpdate();

    return fetch(spreeDataUrl, init)
      .then(response => {
        this._ctaDisabled = false;
        if (response.ok) {
          return response.json();
        }
        this.requestUpdate();
        return response.ok;
      })
      .catch(error => {
        logErrorToSentry(error);
      });
  }

  async setupSpreeData() {
    const productId = this._currentSelectionSpreeData?.id;
    if (!productId) return;

    this.cart = await fetchCart();
    if (this.cart) updateCartIndicator(this.cart.data.attributes.item_count);

    const productAvailabilityResponse = await checkProductAvailability(
      productId
    );

    this._productIsAvailable = !productAvailabilityResponse.isFail();
    if (this._productIsAvailable) {
      this._productProperties = productAvailabilityResponse.success().included;
    } else {
      this._ctaDisabled = true;
      console.warn('Spree product not available');
    }
  }

  async addSelectedProductToCart() {
    if (!this._productIsAvailable || this._ctaDisabled) return;
    useCartConfirmationModal();
    this.cart = await addToCart({
      variantId: this._currentSelectionSpreeData.master_variant_id,
      quantity: this._selectedQuantity,
      analyticsProductId: this._currentSelectionSpreeData.id,
    });
    if (this.cart) {
      updateCartIndicator(this.cart.item_count);
      const productSize = find(this._productProperties, {
        attributes: { name: 'size' },
      });
      changeProductNameInModal(this.content.headerStr, '');
      changeProductImageInModal(this.content.imgUrl);
    }
  }

  get ctaDisabled() {
    return (
      !this.totalPriceString || this._ctaDisabled || !this._productIsAvailable
    );
  }
}
customElements.define('cut-to-order-barrel', CutToOrderBarrel);
